import React, { useState, useMemo } from 'react';
import { VStack, Link } from '@bpba/ui-components';
import ListadoInmuebles from '../components/ListadoInmuebles';
import { Banner, Novelties } from '@bpba/modules-components';
import { TitulosResponsive } from '../model/novedades/TitulosResponsive';

export const Index: React.FC = () => {

    const [idsInmuebles, setIdsInmuebles] = useState<number[]>([]);

    const banners = [
        new Banner(
            0,
            undefined,
            new TitulosResponsive("Bienvenido al nuevo sitio de<br>Oportunidades inmobiliarias", "Bienvenido al nuevo sitio de<br>Oportunidades inmobiliarias", "Bienvenido al nuevo sitio de<br>Oportunidades inmobiliarias"),
            "/CDN/Get/header_consorcios"
        ),
        new Banner(
            1,
            new Link('mailto:ventadeinmuebles@bpba.com.ar'),
            new TitulosResponsive("¿Te interesa? Contactanos", "¿Te interesa? Contactanos", "¿Te interesa? Contactanos"),
            "/CDN/Get/header_empresas",
            'Envianos un mail'
        )]

    return (
        <>
            <VStack display={'flex'} alignItems={'center'}>
                <Novelties
                    orden={0}
                    data={banners}
                />
                <ListadoInmuebles onInmueblesLoaded={setIdsInmuebles} />
            </VStack >
        </>
    );
}